import * as React from 'react';

import type { IconProps } from '../types';

const StatusDone = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 16, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        <path
          fill="hsl(var(--twc-status-icon-done))"
          d="M11.5037 3.92387C11.9541 3.37004 12.7687 3.28615 13.3225 3.73655C13.8763 4.18696 13.9602 5.00154 13.5098 5.55538L7.49436 12.9521C7.27808 13.2181 6.96468 13.387 6.62371 13.4221C6.2827 13.4573 5.94149 13.3557 5.67553 13.1394L2.31324 10.405C1.75949 9.95461 1.67554 9.14001 2.12592 8.58621C2.57632 8.03249 3.39095 7.9486 3.94475 8.39889L6.30397 10.3175L11.5037 3.92387Z"
        />
      </svg>
    );
  }
);

StatusDone.displayName = 'StatusDone';

export { StatusDone };
